// Auth error codes
export const AUTH_CAPTCHA_EXPIRED = 'auth/captcha-expired'
export const AUTH_CODE_EXPIRED = 'auth/code-expired'
export const AUTH_INVALID_EMAIL = 'auth/invalid-email'
export const AUTH_INVALID_MULTI_FACTOR_SESSION =
  'auth/invalid-multi-factor-session'
export const AUTH_INVALID_PHONE_NUMBER = 'auth/invalid-phone-number'
export const AUTH_INVALID_VERIFICATION_CODE = 'auth/invalid-verification-code'
export const AUTH_MULTI_FACTOR_AUTH_REQUIRED = 'auth/multi-factor-auth-required'
export const AUTH_REQUIRES_RECENT_LOGIN = 'auth/requires-recent-login'
export const AUTH_SECOND_FACTOR_ALREADY_IN_USE = 'auth/second-factor-already-in-use'
export const AUTH_TOO_MANY_REQUESTS = 'auth/too-many-requests'
export const AUTH_USER_NOT_FOUND = 'auth/user-not-found'
export const AUTH_USER_TOKEN_EXPIRED = 'auth/user-token-expired'
export const AUTH_WRONG_PASSWORD = 'auth/wrong-password'
